import { render, staticRenderFns } from "./ItemSkeleton.vue?vue&type=template&id=b70875ae"
import script from "./ItemSkeleton.vue?vue&type=script&lang=js"
export * from "./ItemSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports